import { createElement, type ReactNode } from 'react';
import type { CellContext, CellEditor, ResolvedColumn } from '../../domain';
import { resolveBuiltInEditor } from './CellSelectEditor';

export interface EditableCellResult {
    editing: boolean;
    node: ReactNode;
}

export function renderEditableCell<T>(
    col: ResolvedColumn<T>,
    ctx: CellContext<T>,
    content: ReactNode,
): EditableCellResult {
    const editor: CellEditor<T> | undefined = col.editable
        ? col.editor ?? resolveBuiltInEditor(col)
        : undefined;

    if (!editor) {
        return { editing: false, node: content };
    }

    const commit = (newValue: unknown): void => {
        col.onCellChange?.({ ...ctx, newValue });
    };
    const cancel = (): void => undefined;

    return {
        editing: true,
        node: createElement(editor, {
            value: ctx.value,
            ctx,
            onCommit: commit,
            onCancel: cancel,
        }),
    };
}
